import imageMachine from 'fieldwork/helpers/imageMachine'
import baseImageWidths from './baseImageWidths'

const projectCardImages = imageMachine( baseImageWidths )( {
  h: 0.6,
  defaultWidth: 1025,
} )

export default projectCardImages